import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="bg-white" data-testid="not-found-page">
      <div className="cnl-container py-32 text-center">
        <div className="mono text-[12px] font-semibold uppercase tracking-[0.22em] text-[#2563EB]">
          Error 404
        </div>
        <h1 className="mt-4 text-5xl sm:text-6xl font-bold tracking-tight text-[#0B192C]">
          Page not found.
        </h1>
        <p className="mt-5 text-[15px] text-gray-600 max-w-md mx-auto">
          The page you were looking for doesn’t exist or has been moved.
        </p>
        <Link
          to="/"
          className="mt-9 inline-flex items-center justify-center rounded-sm bg-[#0B192C] px-7 py-4 text-[13px] font-semibold uppercase tracking-[0.16em] text-white transition-colors hover:bg-[#1E3E62]"
          data-testid="notfound-home-link"
        >
          Back to Home
        </Link>
      </div>
    </section>
  );
}
